import { useRef, useEffect, useState } from 'react';
import { StyledCheckIcon, StyledCloseIcon } from './PricingFeature.style';

export const useTokensTable = () => {
  const [isBrowser, setIsBrowser] = useState(false);
  const tableRef = useRef(null);
  const stickyHeaderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsBrowser(entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (tableRef.current) {
      observer.observe(tableRef.current);
    }

    return () => {
      if (tableRef.current) {
        observer.unobserve(tableRef.current);
      }
    };
  }, []);

  const renderCellValue = (value) => {
    if (value === true) return <StyledCheckIcon />;
    if (value === false) return <StyledCloseIcon />;
    return value;
  };

  return {
    isBrowser,
    tableRef,
    stickyHeaderRef,
    renderCellValue
  };
};